export const CLI_ERROR_CODES = {
  BAD_USAGE: "BAD_USAGE",
  /** The session needs a person — the exit-3 family. */
  NEEDS_HUMAN: "NEEDS_HUMAN",
  NOT_AUTHENTICATED: "NOT_AUTHENTICATED",
  NETWORK: "NETWORK",
  TIMEOUT: "TIMEOUT",
  /** Ctrl-C: a cancellation, not a failure of ours. */
  INTERRUPTED: "INTERRUPTED",
  /** A 2xx whose shape this CLI version does not understand. */
  API_SCHEMA_MISMATCH: "API_SCHEMA_MISMATCH",
  /** Not JSON at all — wrong host, proxy, error page. */
  NON_JSON_RESPONSE: "NON_JSON_RESPONSE",
  ERROR: "ERROR",
} as const;
